import { display } from "html2canvas/dist/types/css/property-descriptors/display"
import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    container: {
      width: '100%',
      height: '100%',
      paddingTop: '50px',
      paddingRight: '40px',
      paddingBottom: '10px',
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative',
    },
    tabs: {
      width: '100%',
      '& .MuiTabs-flexContainer': {
        columnGap: '10px',
        paddingLeft: '48px',
      },
      '& .MuiTab-root': {
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
        backgroundColor: 'white',
        bordeR: '1px solid black',
        color: colors.color10,
        '& .MuiTabs-scroller': {
          overflow: 'auto',
        },
        '&.Mui-selected': {
          backgroundColor: `${colors.color5}`,
          color: colors.primary,
          boxShadow: `0 0 2px ${colors.color10}`,
          fontWeight: '600',
        },
      },
      '& .MuiTabs-indicator': {
        backgroundColor: 'transparent',
      },
      paddingTop: 1
    },
    containerAction: {
      display: 'flex',
      justifyContent: 'center'
    },
    areaTitle: {
      fontSize: '12px',
      color: colors.color10,
      display: 'flex',
      alignItems: 'center'
    },
    viewMore: {
      fontSize: '1rem',
      color: colors.color16,
      '& .MuiSvgIcon-root': {
        fontSize: '14px',
      },
      '&.MuiIcon-root': {
        fontSize: '14px',
        height: '18px',
        width: '18px',
      },
    },
    action: {
      width: '50%',
      display: 'flex',
      justifyContent: 'start',
      flexWrap: 'wrap',
      '& .MuiCheckbox-root': {
        margin: 0
      },
    },
    all: {
      display: 'flex',
      alignItems: 'center',
      '& .remove-m': {
        margin: '0px'
      },
      '& .MuiTypography-root': {
        fontSize: '12px',
        fontWeight: '400',
        color: 'white'
      }
    },
    checkLabel: {
      color: colors.color5,
      fontWeigt: '800',
      fontSize: '12px',
      maxWidth: '120px',
      wordBreak: 'break-word'
    },
    fileName: {
      '&.MuiTypography-root': {
        fontSize: '12px',
        color: colors.color4,
      },
      textDecoration: 'underline',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    fileTypeName: {
      '&.MuiTypography-root': {
        fontSize: '12px',
        color: colors.color10,
      },
    },
    fileNameNoSee: {
      '&.MuiTypography-root': {
        fontSize: '12px',
        color: colors.color13,
      },
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    icon: {
      '& .MuiSvgIcon-root': {
        width: '2em',
        height: '2em',
        color: colors.color8
      }
    },
    children: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    expand: {
      position: 'absolute',
      bottom: '5px',
      right: '5px',
      color: colors.color5,
      backgroundColor: '#00000022',
      fontSize: '25px',
      width: '30px',
      height: '30px',
      '& .MuiSvgIcon-root': {
        fontSize: 'inherit',
        width: 'inherit',
        height: 'inherit'
      }
    },
    videos: {
      width: '100%',
      height: '120px',
      position: 'relative',
      '& video': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      margin: '0px'
    },
    images: {
      width: '100%',
      height: '120px',
      position: 'relative',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      margin: '0px'
    },
    createTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
      marginBottom: 2,
    },
    fromBox: {
      paddingTop: 5
    }
  }
}

export { useStyles }
